import { useTranslation } from "react-i18next";

interface SwitchProps {
  id?: string;
  checked: boolean | undefined;
  onChange: (value: boolean) => void;
  readOnly?: boolean;
}

export default function Switch({
  id,
  checked,
  onChange,
  readOnly,
}: SwitchProps) {
  const { t } = useTranslation();
  const enabled = Boolean(checked);

  return (
    <div className="flex items-center gap-3">
      <button
        id={id}
        type="button"
        role="switch"
        aria-checked={enabled}
        disabled={readOnly}
        onClick={() => !readOnly && onChange(!enabled)}
        className={`
          relative inline-flex h-8 w-12 items-center rounded-full
          transition-colors duration-300 ease-in-out
          focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2
          ${enabled ? "bg-blue-600" : "bg-gray-300 dark:bg-gray-600"}
          ${readOnly ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}
        `}
      >
        <span
          className={`
            inline-block h-6 w-6 transform rounded-full bg-white shadow-md
            transition-transform duration-300 ease-in-out
            ${enabled ? "translate-x-5" : "translate-x-1"}
          `}
        />
      </button>

      <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
        {t(enabled ? "common.yes" : "common.no")}
      </span>
    </div>
  );
}
